<script>
  import { onMount } from "svelte";
  import * as ss from "simple-statistics";
  import { Tooltip, tooltip } from "@svelte-plugins/tooltips";
  export let map;
  import { radioCheck, topZonesStore } from "../store.js";

  onMount(() => {});
  function systematicSample(data, interval) {
    return data.filter((_, index) => index % interval === 0);
  }

  function downsampleIfNeeded(data, threshold = 5000) {
    if (data.length > threshold) {
      let sampleSize = 1000;
      const interval = Math.floor(data.length / sampleSize);
      return systematicSample(data, interval);
    }
    return data;
  }

  function handleOptionChange(event) {
    $topZonesStore = 0;
    document.getElementById("topZones").value = 0;

    $radioCheck = event.target.value;

    if (!map.getLayer("box-layer")) {
      return;
    }

    if (event.target.checked && map.getLayer("box-layer")) {
      map.removeLayer("box-layer");
      var data = map.getSource("box")._data.features;

      const values = data.map((obj) => obj.properties[$radioCheck]);

      let sortedValues = values.sort((a, b) => a - b);
      sortedValues = downsampleIfNeeded(sortedValues);

      var jenks = ss.jenks(sortedValues, 4);
      console.log(values);
      if (
        event.target.value == "demandNorm" ||
        event.target.value == "needNorm"
      ) {
        map.addLayer(
          {
            id: "box-layer",
            type: "fill",
            source: "box",
            paint: {
              "fill-opacity": 0.8,
              "fill-color": [
                "interpolate",
                ["linear"],
                ["get", `${event.target.value}`],
                0,
                "#af0505",
                jenks[1],
                "orange",
                jenks[2],
                "yellow",
                jenks[3],
                "lightgreen",
                jenks[4],
                "green",
              ],
            },
          },
          "tunnel-path-trail"
        );
        if (map.getLayer("isochroneLayer")) {
          map.moveLayer("isochroneLayer");
        }
        if (map.getLayer("clusterLayer")) {
          map.moveLayer("clusterLayer");
        }
      }
      if (map.getLayer("isochroneLayer")) {
        map.moveLayer("isochroneLayer");
      }
      if (map.getLayer("clusterLayer")) {
        map.moveLayer("clusterLayer");
      }
    }
  }
</script>

<div
  style="position: relative;
    top: -20px;
    margin: 15px;
    font-size:12px"
>
  <label for="option2">
    <span
      use:tooltip={{
        content:
          "<span style='font-size:11px'>Dense areas with good public transport connectivity – we expect micromobility would be well used here</span>",
        position: "top",
        autoPosition: false,
        style: { backgroundColor: "gray" },
        maxWidth: 150,
      }}
    >
      Ridership Potential</span
    ></label
  >

  <input
    type="radio"
    class="choice"
    id="option2"
    name="suit"
    on:change={handleOptionChange}
    value="demandNorm"
    checked
  />
  <label for="option1">
    <span
      use:tooltip={{
        content:
          "<span style='font-size:11px'>Dense areas with poor public transport connectivity – we expect micromobility could make the most improvement to connectivity here</span>",
        position: "top",
        autoPosition: false,
        style: { backgroundColor: "gray" },
        maxWidth: 150,
      }}>Decarbonisation Potential</span
    ></label
  >
  <input
    type="radio"
    class="choice"
    id="option1"
    name="suit"
    value="needNorm"
    on:change={handleOptionChange}
  />
</div>

<style>
  label {
    float: left;
    clear: none;
    display: block;
    padding: 10px 1em 0px 8px;
  }

  input[type="radio"] {
    float: left;
    clear: none;
    margin: 12px 0 0 25px;
  }
  #option2 {
    margin: 12px 0 0 69px;
  }
  .custom-tooltip {
    position: absolute; /* Make tooltip absolute */
    top: -10px; /* Adjust the tooltip's vertical position */
    left: 120%; /* Push it further to the right of the element */
    background-color: #f9f9f9; /* You can also style the tooltip appearance */
    padding: 5px;
    border: 1px solid #ccc;
    z-index: 1000; /* Ensure it stays on top */
  }
</style>
